var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlackLeftArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.259444 6.71295L5.55299 11.9368C5.89429 12.2747 6.44627 12.2703 6.78408 11.9281C7.1219 11.586 7.11842 11.0349 6.77536 10.697L2.99241 6.96371L13.1294 6.96371C13.6108 6.96371 14 6.57455 14 6.09308C14 5.61162 13.6108 5.22241 13.1294 5.22241L2.99241 5.22242L6.77536 1.4891C7.11838 1.15128 7.121 0.600162 6.78408 0.258004C6.61345 0.0856139 6.38881 -0.00144034 6.16418 -0.00144032C5.94302 -0.0014403 5.7219 0.0821331 5.55299 0.249323L0.259444 5.47322C0.0940155 5.63689 -5.53185e-07 5.85981 -5.32787e-07 6.09313C-5.12397e-07 6.32636 0.0931554 6.54838 0.259444 6.71295Z",
    fill: "#29394D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackLeftArrow);
export default __webpack_public_path__ + "static/media/BlackLeftArrow.f83d30e85f5270f10341cc9a56dbe900.svg";
export { ForwardRef as ReactComponent };